import { TBD_ADDRESS } from '@/Overtime/constants/network'
import { LiquidityPoolCollateral } from '@/Overtime/enums/liquidityPool'
import { Network } from '@/Overtime/enums/network'
import type { ContractData } from '@/Overtime/types/viem'

const ABI = [
  {
    inputs: [{ internalType: 'address', name: 'target', type: 'address' }],
    name: 'AddressEmptyCode',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'AddressInsufficientBalance',
    type: 'error',
  },
  { inputs: [], name: 'ERC1167FailedCreateClone', type: 'error' },
  { inputs: [], name: 'EnforcedPause', type: 'error' },
  { inputs: [], name: 'ExpectedPause', type: 'error' },
  { inputs: [], name: 'FailedInnerCall', type: 'error' },
  { inputs: [], name: 'InvalidInitialization', type: 'error' },
  { inputs: [], name: 'NotInitializing', type: 'error' },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'SafeERC20FailedOperation',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Claimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'newProvider',
        type: 'address',
      },
    ],
    name: 'DefaultLiquidityProviderChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'round',
        type: 'uint256',
      },
    ],
    name: 'Deposited',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint64',
        name: 'version',
        type: 'uint64',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'maxAllowedDeposit',
        type: 'uint256',
      },
    ],
    name: 'MaxAllowedDepositChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'maxAllowedUsersChanged',
        type: 'uint256',
      },
    ],
    name: 'MaxAllowedUsersChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'minAllowedDeposit',
        type: 'uint256',
      },
    ],
    name: 'MinAllowedDepositChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'oldOwner',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnerChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnerNominated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Paused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'newMastercopy',
        type: 'address',
      },
    ],
    name: 'PoolRoundMastercopyChanged',
    type: 'event',
  },
  { anonymous: false, inputs: [], name: 'PoolStarted', type: 'event' },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'round',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'roundPnL',
        type: 'uint256',
      },
    ],
    name: 'RoundClosed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'round',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'batchSize',
        type: 'uint256',
      },
    ],
    name: 'RoundClosingBatchProcessed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'round',
        type: 'uint256',
      },
    ],
    name: 'RoundClosingPrepared',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'roundLength',
        type: 'uint256',
      },
    ],
    name: 'RoundLengthChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'round',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'roundPool',
        type: 'address',
      },
    ],
    name: 'RoundPoolCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'safeBoxShare',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'safeBoxAmount',
        type: 'uint256',
      },
    ],
    name: 'SafeBoxSharePaid',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'safeBox',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'safeBoxImpact',
        type: 'uint256',
      },
    ],
    name: 'SetSafeBoxParams',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'sportAMM',
        type: 'address',
      },
    ],
    name: 'SportAMMChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'ticket',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'oldRound',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newRound',
        type: 'uint256',
      },
    ],
    name: 'TicketMigratedToNextRound',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Unpaused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'utilizationRate',
        type: 'uint256',
      },
    ],
    name: 'UtilizationRateChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'WithdrawalRequested',
    type: 'event',
  },
  {
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'addressManager',
    outputs: [
      { internalType: 'contract IAddressManager', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'allocationPerRound',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    name: 'balancesPerRound',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'canCloseCurrentRound',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'closeRound',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'collateral',
    outputs: [{ internalType: 'contract IERC20', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'collateralKey',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'ticket', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'commitTrade',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_roundA', type: 'uint256' },
      { internalType: 'uint256', name: '_roundB', type: 'uint256' },
    ],
    name: 'cumulativePnLBetweenRounds',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'cumulativeProfitAndLoss',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'defaultLiquidityProvider',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'exerciseDefaultRoundTicketsReadyToBeExercised',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_batchSize', type: 'uint256' }],
    name: 'exerciseDefaultRoundTicketsReadyToBeExercisedBatch',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'exerciseTicketsReadyToBeExercised',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_batchSize', type: 'uint256' }],
    name: 'exerciseTicketsReadyToBeExercisedBatch',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'firstRoundStartTime',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getCollateralPrice',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_round', type: 'uint256' }],
    name: 'getNumberOfTradingTicketsPerRound',
    outputs: [
      { internalType: 'uint256', name: 'numOfTickets', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_round', type: 'uint256' }],
    name: 'getRoundEndTime',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_round', type: 'uint256' }],
    name: 'getRoundStartTime',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_ticket', type: 'address' },
      { internalType: 'uint256', name: '_round', type: 'uint256' },
      { internalType: 'uint256', name: '_startIndex', type: 'uint256' },
      { internalType: 'uint256', name: '_endIndex', type: 'uint256' },
    ],
    name: 'getTicketIndexInTicketRound',
    outputs: [
      { internalType: 'uint256', name: 'index', type: 'uint256' },
      { internalType: 'bool', name: 'found', type: 'bool' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_ticket', type: 'address' }],
    name: 'getTicketPool',
    outputs: [{ internalType: 'address', name: 'roundPool', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_ticket', type: 'address' }],
    name: 'getTicketRound',
    outputs: [
      { internalType: 'uint256', name: 'ticketRound', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getUsersCountInCurrentRound',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'hasDefaultRoundTicketsReadyToBeExercised',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'hasTicketsReadyToBeExercised',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'initNonReentrant',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'address', name: '_owner', type: 'address' },
          { internalType: 'address', name: '_sportsAMM', type: 'address' },
          { internalType: 'address', name: '_addressManager', type: 'address' },
          {
            internalType: 'contract IERC20',
            name: '_collateral',
            type: 'address',
          },
          { internalType: 'uint256', name: '_roundLength', type: 'uint256' },
          {
            internalType: 'uint256',
            name: '_maxAllowedDeposit',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_minDepositAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_maxAllowedUsers',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_utilizationRate',
            type: 'uint256',
          },
          { internalType: 'address', name: '_safeBox', type: 'address' },
          { internalType: 'uint256', name: '_safeBoxImpact', type: 'uint256' },
          { internalType: 'bytes32', name: '_collateralKey', type: 'bytes32' },
        ],
        internalType: 'struct SportsAMMV2LiquidityPool.InitParams',
        name: 'params',
        type: 'tuple',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    name: 'isTradingTicketInARound',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_user', type: 'address' }],
    name: 'isUserLPing',
    outputs: [{ internalType: 'bool', name: 'isUserInLP', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxAllowedDeposit',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxAllowedUsers',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address[]', name: '_tickets', type: 'address[]' },
      { internalType: 'uint256', name: '_newRound', type: 'uint256' },
      {
        internalType: 'uint256[]',
        name: '_ticketsIndexInRound',
        type: 'uint256[]',
      },
    ],
    name: 'migrateBatchOfTicketsToAnotherRound',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_ticket', type: 'address' },
      { internalType: 'uint256', name: '_newRound', type: 'uint256' },
      { internalType: 'uint256', name: '_ticketIndexInRound', type: 'uint256' },
    ],
    name: 'migrateTicketToAnotherRound',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'minDepositAmount',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_owner', type: 'address' }],
    name: 'nominateNewOwner',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nominatedOwner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_share', type: 'uint256' }],
    name: 'partialWithdrawalRequest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'poolRoundMastercopy',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'prepareRoundClosing',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_batchSize', type: 'uint256' }],
    name: 'processRoundClosingBatch',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'profitAndLossPerRound',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'round',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'roundClosingPrepared',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'roundLength',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'roundPerTicket',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'roundPools',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'safeBox',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'safeBoxImpact',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_defaultLiquidityProvider',
        type: 'address',
      },
    ],
    name: 'setDefaultLiquidityProvider',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_maxAllowedDeposit', type: 'uint256' },
    ],
    name: 'setMaxAllowedDeposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_maxAllowedUsers', type: 'uint256' },
    ],
    name: 'setMaxAllowedUsers',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_minDepositAmount', type: 'uint256' },
    ],
    name: 'setMinAllowedDeposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '_owner', type: 'address' }],
    name: 'setOwner',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bool', name: '_setPausing', type: 'bool' }],
    name: 'setPaused',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_poolRoundMastercopy',
        type: 'address',
      },
    ],
    name: 'setPoolRoundMastercopy',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_roundLength', type: 'uint256' },
    ],
    name: 'setRoundLength',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_safeBox', type: 'address' },
      { internalType: 'uint256', name: '_safeBoxImpact', type: 'uint256' },
    ],
    name: 'setSafeBoxParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract ISportsAMMV2',
        name: '_sportsAMM',
        type: 'address',
      },
    ],
    name: 'setSportsAMM',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '_utilizationRate', type: 'uint256' },
    ],
    name: 'setUtilizationRate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'sportsAMM',
    outputs: [
      { internalType: 'contract ISportsAMMV2', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'start',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'started',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    name: 'ticketAlreadyExercisedInRound',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalDeposited',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'uint256', name: '', type: 'uint256' },
    ],
    name: 'tradingTicketsPerRound',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'proxyAddress', type: 'address' },
    ],
    name: 'transferOwnershipAtInit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_ticket', type: 'address' },
      { internalType: 'uint256', name: '_amount', type: 'uint256' },
    ],
    name: 'transferToPool',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    name: 'userInRound',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'usersCurrentlyInPool',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: '', type: 'uint256' },
      { internalType: 'uint256', name: '', type: 'uint256' },
    ],
    name: 'usersPerRound',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'usersProcessedInRound',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'utilizationRate',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdrawalRequest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'withdrawalRequested',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'withdrawalShare',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
]

const liquidityPoolContractV2: Record<LiquidityPoolCollateral, ContractData> = {
  [LiquidityPoolCollateral.THALES]: {
    addresses: {
      [Network.OptimismMainnet]: '0xE59206b08cC96Da0818522C75eE3Fd4EBB7c0A47',
      [Network.Arbitrum]: '0x9733AB157f5A89f0AD7460d08F869956aE2018dA',
      [Network.Base]: TBD_ADDRESS,
      [Network.OptimismSepolia]: '0x93ca60840984348f8Dc4d81e274a12CAaDDC59aE',
    },
    abi: ABI,
  },
  [LiquidityPoolCollateral.USDC]: {
    addresses: {
      [Network.OptimismMainnet]: '0x0fe1044Fc8C05482102Db14368fE88791E9B8698',
      [Network.Arbitrum]: '0x22D180F39A0eB66098cf839AF5e3C6b009383B6A',
      [Network.Base]: '0xf86e90412F52fDad8aD8D1aa2dA5B2C9a7e5f018',
      [Network.OptimismSepolia]: '0xAE145Fe3Af36aAE9135c488E9B728eD504B2385C',
    },
    abi: ABI,
  },
  [LiquidityPoolCollateral.WETH]: {
    addresses: {
      [Network.OptimismMainnet]: '0x4f2822D4e60af7f9F70E7e45BC1941fe3461231e',
      [Network.Arbitrum]: '0xcB4728a1789B87E05c813B68DBc5E6A98a4856bA',
      [Network.Base]: '0xcc4ED8cD7101B512B134360ED3cCB759caB33f17',
      [Network.OptimismSepolia]: '0xCb99b139a30fa2C09a8396B4a1cCda06D91DdC72',
    },
    abi: ABI,
  },
  [LiquidityPoolCollateral.OVER]: {
    addresses: {
      [Network.OptimismMainnet]: '0x59a7A8Ae9d58D69a69b6A24770EC771110647226',
      [Network.Arbitrum]: '0xc5f5186b46c84bF63a9e166bfa2175D9bc391ce2',
      [Network.Base]: '0xB4199DC163F3206643649E117A816ad0DECb6C3B',
      [Network.OptimismSepolia]: TBD_ADDRESS,
    },
    abi: ABI,
  },
  [LiquidityPoolCollateral.cbBTC]: {
    addresses: {
      [Network.OptimismMainnet]: TBD_ADDRESS,
      [Network.Arbitrum]: TBD_ADDRESS,
      [Network.Base]: '0x8d4f838327DedFc735e202731358AcFc260c207a',
      [Network.OptimismSepolia]: TBD_ADDRESS,
    },
    abi: ABI,
  },
  [LiquidityPoolCollateral.wBTC]: {
    addresses: {
      [Network.OptimismMainnet]: TBD_ADDRESS,
      [Network.Arbitrum]: '0xbD08D8F8c17C22fb0a12Fe490F38f40c59B60d2A',
      [Network.Base]: TBD_ADDRESS,
      [Network.OptimismSepolia]: TBD_ADDRESS,
    },
    abi: ABI,
  },
}

export default liquidityPoolContractV2
